import { ContentFooter } from "@app/components/core/ContentFooter/ContentFooter"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import DateSelectionCalendar from "@app/components/order/DateSelectionCalendar/DateSelectionCalendar"
import DateSelectionTicketstack from "@app/components/order/DateSelectionTicketstack/DateSelectionTicketstack"
import OrderContentBody from "@app/components/order/OrderContentBody/OrderContentBody"
import OrderSubPage from "@app/components/pageTypes/OrderSubPage/OrderSubPage"
import { OrderAnimationTypes } from "@app/components/routing/AnimatedOrderRoute/AnimatedOrderRoute"
import { useGetStrings, useGetZone } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { OrderErrors, TICKET_TYPES } from "@app/utils/constants"
import { selectDateSelectionPrice, selectIsDateSelectionValid } from "@app/utils/selectors"
import tracking from "@app/utils/tracking"
import { hasDifferentPrice } from "@app/utils/zoneUtils"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect } from "react"
import "./DateSelection.css"

export default function DateSelection() {
	const selectedDay = useSelector(state => state.order.selectedDay)
	const selectedTs = useSelector(state => state.order.selectedTs)
	const selectedTbKind = useSelector(state => state.order.selectedTbKind)
	const isValid = useSelector(selectIsDateSelectionValid)
	const price = useSelector(selectDateSelectionPrice)
	const priceNoSelection = useSelector("order.visitorKindPrice")

	const { data: zone } = useGetZone(appStore.get("core.zoneId"))
	const { push } = useCustomNavigation()

	const {
		data: { buttonNext, buttonLoungerSelection, dateSelectionTitle, ticketTypeAreaAvailableLabel, timeslotAreaAvailableLabel },
	} = useGetStrings(undefined, { defaultData: {} })

	useEffect(() => {
		appStore.set(state => ({
			order: {
				...state.order,
				loungers: [],
			},
		}))

		if (isValid) {
			//we come back to this page after a selection was succesfullymade (back from loungers etc)
			tracking.removeTickets()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const nextPage = useCallback(() => {
		tracking.addTickets()
		tracking.date()

		const relation = appStore.get("core.relation")
		const isHandicapped = relation && relation.tags ? (relation.tags.find(e => e.tag === "Handicap") ? true : false) : false

		if (appStore.get("core.kioskMode") === true) {
			push("/order/order-overview", OrderAnimationTypes.fullSlide)
			return
		}

		if (!zone.useLoungers) {
			push("/order/bluphoria-selection", OrderAnimationTypes.fullSlide)
			tracking.beds()
		} else if (selectedTbKind.timeBlocks[0].timeBlockTypeId === TICKET_TYPES.WholeDay && selectedTbKind.timeBlocks[0].items[0].objectCapacity != 0) {
			if (isHandicapped) {
				push("/order/lounger-selection", OrderAnimationTypes.fullSlide)
			} else {
				push("/order/lounger-selection", OrderAnimationTypes.fullSlide)
			}
		} else {
			tracking.beds()
			push("/order/bluphoria-selection", OrderAnimationTypes.fullSlide)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTbKind])

	//IF we didn#t sellect a timeslot and our tbKind has different prices then show a from value | dont absolute the price
	let priceAbsolute = false
	let hasDiff = selectedTbKind ? hasDifferentPrice(selectedTbKind) : false
	if (selectedTbKind) {
		priceAbsolute = !hasDiff

		if (selectedTs) {
			priceAbsolute = true
		}
	}

	return (
		<OrderSubPage>
			<ContentHeader canGoBack colorStyle="white" animation={OrderAnimationTypes.fullSlide} process={2}>
				{dateSelectionTitle}
			</ContentHeader>
			<OrderContentBody>
				<DateSelectionCalendar />
				<DateSelectionTicketstack />
				<div role="status" className="sr-only">
					{selectedDay ? ticketTypeAreaAvailableLabel : ""}
				</div>
				<div role="status" className="sr-only">
					{selectedTbKind && selectedTbKind.timeBlocks[0].timeBlockTypeId !== TICKET_TYPES.WholeDay ? timeslotAreaAvailableLabel : ""}
				</div>
			</OrderContentBody>
			<ContentFooter
				process={2}
				price={price || priceNoSelection}
				priceAbsolute={priceAbsolute}
				buttonProps={{
					text: appStore.get("core.kioskMode")
						? buttonNext
						: selectedTbKind &&
							  selectedTbKind.timeBlocks[0].timeBlockTypeId === TICKET_TYPES.WholeDay &&
							  selectedTbKind.timeBlocks[0].items[0].objectCapacity != 0
							? buttonLoungerSelection
							: buttonNext,
					disabled: !isValid,
					onNext: nextPage,
					style: "secondary",
					disabledReason: !selectedDay
						? OrderErrors.noSelectedDate
						: !selectedTbKind
							? OrderErrors.noSelectedTicket
							: !selectedTs
								? OrderErrors.noSelectedTimeslot
								: "",
				}}
			/>
		</OrderSubPage>
	)
}
